import { RoleAPIClient } from 'module/api/role';
import { axiosInstance } from 'api/axios';

export const RolesApi = new RoleAPIClient(axiosInstance);
